module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/playlist-1-7790491b7c6c4847a409a29388a98d74.svg";